// import case names
import { filter, isEmpty, get, cloneDeep, set, forEach, find, isUndefined, findIndex, indexOf, isEqual, differenceWith, size } from 'lodash';
import { SELECT_ALL_OPTION_VALUE } from 'constants/common';

/**
 * @type {function}
 * @desc Resolvers are pure functions used for resolving templates (React components) or to transform some data.
 * A resolver function takes an `id` and an optional `payload` and returns a `result`.
 * Based on `switch` cases inside this function, correct `result` should be returned.
 * @param {object} payload
 * @example
 * import { reportCallCallerTypeselectionResolver } from 'resolvers/reportCallCallerTypeselection';
 */
export const reportCallCallerTypeselectionResolver = ( { filterData, optionType, optionValue } ) => {
    
    const callCallerType = cloneDeep( get( filterData, 'options.callCallerType' ) );
    const filterValue = get( filterData, 'filter' );
    const isValueAdded = -1 !== indexOf( filterValue[ optionType ], optionValue ) ? true: false;
    const callerTypeOptions = cloneDeep( get( filterData, 'options.callerTypeOptions' ) );

    if( 'callType' === optionType ) {

        if( SELECT_ALL_OPTION_VALUE === optionValue ) {

            if( isValueAdded ) {

                // get the list common values
                let combinedValues = [];
                forEach( callCallerType, callType => {
                    if( SELECT_ALL_OPTION_VALUE !== callType.value  ) {
                        combinedValues = isEmpty( combinedValues ) ? callType.options : differenceWith( combinedValues, callType.options, isEqual );
                    }
                } );
    
                forEach( callerTypeOptions, callTypeOption => {
                    if( SELECT_ALL_OPTION_VALUE === callTypeOption.value  ) {
                        callTypeOption.disabled = true;
                    } else {
                        callTypeOption.disabled = ! isUndefined( find( combinedValues, { value: callTypeOption.value } ) );
                    }
                } );
                set( filterData, 'options.callerTypeOptions', callerTypeOptions );

            } else {

                // update the values from disabled to enable
                forEach( callerTypeOptions, callType => {
                    callType.disabled = false;
                } );
                set( filterData, 'options.callerTypeOptions', callerTypeOptions );
            }

        } else {
            const applicableOptions = find( callCallerType, { value: optionValue } )[ 'options' ];
            forEach( callerTypeOptions, option => {
                const doesOptionExist = find( applicableOptions, { value: option.value } );
                if( ! isValueAdded || ! isUndefined( doesOptionExist ) ) {
                    option.disabled = false;
                } else {
                    option.disabled = true;
                }
                
            } );
            set( filterData, 'options.callerTypeOptions', callerTypeOptions );
        }

    } else {

        if( SELECT_ALL_OPTION_VALUE === optionValue ) {

            if( isValueAdded ) {
                forEach( callCallerType, callCallerTypeOption => {
                    if( SELECT_ALL_OPTION_VALUE !== callCallerTypeOption.value ) {
                        callCallerTypeOption.disabled = ! isEqual( size( callCallerTypeOption.options ), size( callerTypeOptions ) - 1 );
                    } else {
                        callCallerTypeOption.disabled = true;
                    }
                } );
                set( filterData, 'options.callCallerType', callCallerType );

            } else {
                forEach( callCallerType, _callType => {
                    _callType.disabled = false;
                } );
                set( filterData, 'options.callCallerType', callCallerType );
            }

        } else {

            const compareValues = filterValue[ optionType ];
            forEach( callCallerType, _callType => {

                if( SELECT_ALL_OPTION_VALUE !== _callType.value ) {
                    const options = filter( compareValues, optionVal => {
                        return ! isUndefined( find( _callType.options, { value: optionVal } ) );
                    } );
                    if( isEqual( compareValues, options ) ) {
                        _callType.disabled = false;
                    } else {
                        _callType.disabled = true;
                    }
                }

            } );

            const disabledOptions = filter( callCallerType, _option => {
                return _option.disabled && _option.value !== SELECT_ALL_OPTION_VALUE;
            } );

            const callCallerTypeAllIndex = findIndex( callCallerType, { value: SELECT_ALL_OPTION_VALUE } );
            if( ! isEmpty( disabledOptions ) ) {
                callCallerType[ callCallerTypeAllIndex ].disabled = true;
            } else {
                callCallerType[ callCallerTypeAllIndex ].disabled = false;
            }
            set( filterData, 'options.callCallerType', callCallerType );
        }
    }

    return filterData;
};
